/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAnalyticsTotalSubnetCallCountRequest = {
    period?: KiteAnalyticsTotalSubnetCallCountRequest.period;
};

export namespace KiteAnalyticsTotalSubnetCallCountRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

